import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { mergeWorkspaceQuizzes } from '../../../api/workspaces/quizzes/mergeWorkspaceQuizzes';

export function useMergeWorkspaceQuizzes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mergeWorkspaceQuizzes,
    onSettled: (_data, _error, { workspaceId }) =>
      queryClient.invalidateQueries(
        workspaceKeys.quizzes({ workspaceId, isDeleted: false })
      ),
  });
}

export type UseMergeWorkspaceQuizzesMutation = ReturnType<
  typeof useMergeWorkspaceQuizzes
>;
